// Hukuki sayfalar (footer'daki sözleşme ve güvenlik metinleri) için ortak ayarlar.
// Şirket / iletişim bilgisi tek yerden değişsin diye metinler {brand}, {company}, {email}, {site}
// yer tutucularıyla yazıldı; .env ile de ezilebilir.

export const LEGAL_INFO = {
  brand: process.env.VUE_APP_LEGAL_BRAND || 'Boho',
  company: process.env.VUE_APP_LEGAL_COMPANY || 'Arasana İnternet İletişim ve Telekomünikasyon Ltd. Şti.',
  companyShort: process.env.VUE_APP_LEGAL_COMPANY_SHORT || 'Arasana',
  email: process.env.VUE_APP_LEGAL_EMAIL || 'support@boholive.app',
  site: process.env.VUE_APP_LEGAL_SITE || 'https://www.boholive.app',
}

// slug -> i18n anahtarı (legal.docs.<key>)
export const LEGAL_DOCS = [
  {
    slug: 'membership-agreement', key: 'membershipAgreement', group: 'agreements', icon: 'FileTextIcon',
  },
  {
    slug: 'terms-of-service', key: 'termsOfService', group: 'agreements', icon: 'BookOpenIcon',
  },
  {
    slug: 'privacy-policy', key: 'privacyPolicy', group: 'agreements', icon: 'LockIcon',
  },
  {
    slug: 'community-guidelines', key: 'communityGuidelines', group: 'safety', icon: 'UsersIcon',
  },
  {
    slug: 'content-safety', key: 'contentSafety', group: 'safety', icon: 'ShieldIcon',
  },
  {
    slug: 'child-safety', key: 'childSafety', group: 'safety', icon: 'HeartIcon',
  },
]

export const LEGAL_LOCALES = ['en', 'tr', 'ar', 'de', 'es', 'fr', 'pt', 'ru', 'ua']

// Sözleşme metinleri (gövde) tüm dillerde standart İngilizce gösterilir; başlıklar/isimler i18n ile
// kullanıcının diline göre çevrilir. Çevrilmiş gövdeleri açmak için null yapın (content/<dil>.json kullanılır).
export const LEGAL_BODY_LOCALE = 'en'

export function findLegalDoc(slug) {
  return LEGAL_DOCS.find(d => d.slug === slug) || null
}

const cache = {}

// Metin gövdeleri büyük olduğu için her dil ayrı chunk olarak, ihtiyaç anında yüklenir.
export function loadLegalContent(locale) {
  const wanted = LEGAL_BODY_LOCALE || locale
  const lang = LEGAL_LOCALES.includes(wanted) ? wanted : 'en'
  if (!cache[lang]) {
    cache[lang] = import(/* webpackChunkName: "legal-[request]" */ `./content/${lang}.json`)
      .then(m => m.default || m)
      .catch(err => {
        delete cache[lang]
        if (lang !== 'en') return loadLegalContent('en')
        throw err
      })
  }
  return cache[lang]
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

// "[[slug|metin]]" -> iç bağlantı, "{email}" -> mailto, diğer yer tutucular -> düz metin
export function renderLegalText(text, info = LEGAL_INFO) {
  return escapeHtml(text)
    .replace(/\[\[([a-z-]+)\|([^\]]+)\]\]/g, (m, slug, label) => `<a href="/legal/${slug}" data-legal-link="${slug}">${label}</a>`)
    .replace(/\{email\}/g, `<a href="mailto:${info.email}">${info.email}</a>`)
    .replace(/\{site\}/g, `<a href="${info.site}" target="_blank" rel="noopener">${info.site.replace(/^https?:\/\//, '')}</a>`)
    .replace(/\{brand\}/g, escapeHtml(info.brand))
    .replace(/\{company\}/g, escapeHtml(info.company))
}
